import { render, staticRenderFns } from "./Bcp.vue?vue&type=template&id=2ebbbd92&scoped=true"
import script from "./Bcp.vue?vue&type=script&lang=ts"
export * from "./Bcp.vue?vue&type=script&lang=ts"
import style0 from "./Bcp.vue?vue&type=style&index=0&id=2ebbbd92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebbbd92",
  null
  
)

export default component.exports